import * as React from 'react';

type TimeoutFunction = (...args: any[]) => void;

export const useDebounce = (timeout: number) => {
  const timer = React.useRef<ReturnType<typeof setTimeout>>();

  const reset = (func: TimeoutFunction, overrideTimeout?: number) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(func, overrideTimeout || timeout);
  };

  return reset;
};
